"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var ReportModule = /** @class */ (function (_super) {
    __extends(ReportModule, _super);
    function ReportModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询房间营收报表
     * @param curYearMonth 结算月份
     * @param isImported 0 未结算，1 已结算， 2 已打款
     * @param owner 业主(搜索业主姓名、手机号)
     * @param roomId 房间ID(搜索蓝主人房间ID、Xbed房间ID)
     * @param xbedRoomName Xbed房间名(搜索Xbed房间名)
     * @param xbedRoomNo 房号(搜索房号)
     * @param page 页数
     * @param size 每页行数
     * @param token
     */
    ReportModule.prototype.queryRoomsMonthIncomeList = function (params, token) {
        return this.gatewayClient.queryRoomsMonthIncomeList(params, token);
    };
    /**
     * 查询业主营收报表
     * @param curYearMonth 结算月份
     * @param isImported 0 未结算，1 已结算， 2 已打款
     * @param owner 业主(搜索业主姓名、手机号)
     * @param page 页数
     * @param size 每页行数
     * @param token
     */
    ReportModule.prototype.queryOwnerRoomsMonthList = function (params, token) {
        return this.gatewayClient.queryOwnerRoomsMonthList(params, token);
    };
    /**
     * 年月列表
     */
    ReportModule.prototype.queryYearMouth = function (token) {
        return this.gatewayClient.queryYearMouth(token);
    };
    return ReportModule;
}(gateway_module_1.GatewayModule));
exports.ReportModule = ReportModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9yZXBvcnQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsb0RBQWtEO0FBRWxEO0lBQWtDLGdDQUFhO0lBQS9DOztJQXlEQSxDQUFDO0lBeERDOzs7Ozs7Ozs7OztPQVdHO0lBQ0ksZ0RBQXlCLEdBQWhDLFVBQ0UsTUFTQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyx5QkFBeUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDckUsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksK0NBQXdCLEdBQS9CLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyx3QkFBd0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDcEUsQ0FBQztJQUVEOztPQUVHO0lBQ0kscUNBQWMsR0FBckIsVUFBc0IsS0FBYTtRQUNqQyxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDbEQsQ0FBQztJQUNILG1CQUFDO0FBQUQsQ0FBQyxBQXpERCxDQUFrQyw4QkFBYSxHQXlEOUM7QUF6RFksb0NBQVkifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/report/index.js
// module id = 222
// module chunks = 44